module.exports = __webpack_public_path__ + "static/media/rank-08-senior.6df6060f.svg";